//#region Vars
import { createWebHistory, createRouter } from "vue-router";
import { nextTick } from 'vue';
//#endregion
//#region New
const router = createRouter({
    history: createWebHistory(),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve({
                        top: savedPosition.top,
                        left: savedPosition.left,
                    });
                }, 500);
            });
        }
        else {
            window.scrollTo(0, 0);
            return false;
        }
    },
    routes: [
        {
            name: "not-found",
            path: "/:catchAll(.*)",
            components: {
                default: {
                    template: '<g-error-page />'
                }
            },
            meta: {
                title: "Sorry",
                allowAnonymous: true,
                layout: "g-clean-layout"
            }
        }
    ],
});
router.openWindow = (address) => {
    // #region Check
    if (!address) {
        return;
    }
    if (!router.currentRoute.value?.segements) {
        return;
    }
    // #endregion
    // #region Vars
    let tCurrent = router.currentRoute.value;
    let tSegements = [];
    //Load
    tCurrent.segements.forEach(s => { tSegements.push(s.path); });
    // #endregion
    // #region String
    if (typeof address === "string") {
        tSegements.push(address);
    }
    // #endregion
    // #region Address
    else {
        //Calculate
        utils.routing.calculateSegement(address);
        //Pust
        tSegements.push(address.path);
    }
    // #endregion
    // #region Push      
    let tNew = {
        name: tCurrent.name,
        query: tCurrent.query,
        hash: tCurrent.hash,
        params: {
            segement: tSegements
        }
    };
    if (tSegements.length == 0) {
        return;
    }
    //Set
    {
        router.push(tNew);
    }
    // #endregion    
};
router.closeWindow = async (segment) => {
    let tCurrent = router.currentRoute.value;
    let tSegements = [];
    tCurrent.segements.forEach(s => {
        if (s.index < segment.index) {
            tSegements.push(s.path);
        }
    });
    let tNew = {
        name: tCurrent.name,
        query: tCurrent.query,
        hash: tCurrent.hash,
        params: {
            segement: tSegements
        }
    };
    //Set
    {
        await router.push(tNew);
    }
    return true;
};
router.closeCurrentWindow = async (component) => {
    //Find
    let tRef = utils.findVueComponent(component, ["g-modal-popup", "g-modal-slide", "g-entity-page"]);
    //Run
    if (!tRef) {
        return false;
    }
    let tWindow = tRef.window;
    {
        if (!tWindow) {
            return false;
        }
    }
    //Close
    {
        await router.closeWindow(tWindow);
    }
    return true;
};
router.updateWindow = (segment) => {
    // #region Vars
    let tCurrent = router.currentRoute.value;
    // #endregion
    // #region Calculate
    utils.routing.calculateSegement(segment);
    // #endregion
    // #region Set
    tCurrent.segements.forEach(e => {
        if (e.index === segment.index) {
            e.path = segment.path;
        }
    });
    let tSegements = [];
    tCurrent.segements.forEach(s => {
        tSegements.push(s.path);
    });
    // #endregion
    // #region New
    let tNew = {
        name: tCurrent.name,
        query: tCurrent.query,
        hash: tCurrent.hash,
        params: {
            segement: tSegements
        }
    };
    if (tSegements.length == 0) {
        return;
    }
    //Set
    {
        router.push(tNew);
    }
    // #endregion
};
router.beforeEach(async (to, from, next) => {
    // #region Old
    if (to.fullPath.startsWith('/#/')) {
        return next({
            path: to.fullPath.substr(2, to.fullPath.length - 2),
            hash: '',
            replace: true
        });
    }
    // #endregion
    // #region **Menu
    host.pageMeta.hideMobileNav();
    // #endregion
    // #region **Meta
    host.pageMeta.resetMeta();
    // #endregion
    // #region Logout
    if (to.name === "logout") {
        if (host.session.isAuthenticated) {
            await host.login.logout();
        }
        let tRoute = router.resolve({
            name: 'home',
        });
        if (tRoute?.meta?.allowAnonymous) {
            return next({
                name: 'home'
            });
        }
        else {
            return next({
                name: 'login'
            });
        }
    }
    // #endregion
    // #region Login
    if (to.name === "login" && host.session.isAuthenticated) {
        if (to.query?.returnUrl) {
            //Parse
            let tUrl = decodeURIComponent(to.query?.returnUrl);
            //Special
            if (tUrl.startsWith('/#')) {
                return next({ path: tUrl.substr(2), });
            }
            else {
                window.location.href = tUrl;
                return next();
            }
        }
        else {
            return next({ path: '/', });
        }
    }
    // #endregion
    // #region Event-Bus
    let tArgs = {
        to: to,
        from: from,
        next: next,
        cancel: false
    };
    //Run
    await host.eventBus.emit('router-beforeLeave', tArgs);
    //Cancel
    if (tArgs.cancel) {
        return;
    }
    // #endregion
    // #region Defualt
    if (to.meta.allowAnonymous !== undefined && to.meta.allowAnonymous) {
        return next();
    }
    if (!host.session.isAuthenticated) {
        return next({
            name: 'login',
            query: {
                returnUrl: to.fullPath === '/' ? undefined : encodeURIComponent('/#' + to.fullPath)
            },
        });
    }
    // #endregion
    return next();
});
router.afterEach((to, from) => {
    if (to.meta.isSegementRoute) {
        let tSegements = utils.routing.getSegements(to);
        //All
        to.segements = tSegements.segments;
        to.segmentPage = tSegements.segmentPage;
        //Optimize
        if (to.segmentPage?.navigation?.meta) {
            to.meta = { ...to.meta, ...to.segmentPage?.navigation?.meta };
        }
    }
    //Navigation
    nextTick(() => {
        //Breadrcum
        if (to.meta?.breadcrumb) {
            host.store.commit('navigation/setBreadcrumb', to.meta?.breadcrumb);
        }
        //Title
        host.pageMeta.title = to.meta?.title;
        host.pageMeta.options = to.meta?.options;
    });
});
// #endregion
export default router;
